module.exports = __webpack_public_path__ + "media/images/solutions-supporting-2-54909e541c673f1fe8b6938a059c5341.svg";